export const getters = {
  getFaqData: function (state) {
    return state.faqData;
  },

  mapData: function (state) {
    return state.storeData;
  },
};
